export const fieldsMaxLength = {
  ein: 9,
  fileNumber: 7,
  address: 100,
  email: 100,
  name: 100,
  middleName: 100,
  lastName: 100,
};
